import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchappliedappraisalById = createAsyncThunk(
    'performance/fetchRoleApprasialById',
    async ( Id: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/appliedappraisal/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Apprasial');
        }
    }
);

export const createappliedappraisal = createAsyncThunk(
    'performance/createappliedappraisal',
    async ( data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post(`/performance/appliedappraisal`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Apprasial');
        }
    }
);
export const updateappliedappraisalrating = createAsyncThunk(
    'performance/updateappliedappraisal',
    async ( data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.put(`/performance/appliedappraisal/rating/update`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Apprasial');
        }
    }
);
